import {
  fetchLessonClassAdvisoryMeeting,
  fetchLessonClassAdvisoryMeetingFilters,
} from "classroom/api/teacher";
import type { FilterResource } from "api/generated";
import type { TransitionMeetingMyStudentsOverview } from "meetings/advisory/types";
import { defineStore } from "pinia";

export const useClassroomLessonClassAdvisoryMeetingStore = defineStore(
  "classroomLessonClassAdvisoryMeeting",
  () => {
    const loadAdvisoryMeeting = async (
      scheduleId: string,
      params: Record<string, string> = {},
      signal?: AbortSignal,
    ): Promise<TransitionMeetingMyStudentsOverview> => {
      return fetchLessonClassAdvisoryMeeting(scheduleId, params, signal);
    };

    const loadAdvisoryMeetingFilters = async (
      scheduleId: string,
      signal?: AbortSignal,
    ): Promise<FilterResource[]> => {
      return fetchLessonClassAdvisoryMeetingFilters(scheduleId, signal);
    };

    return { loadAdvisoryMeeting, loadAdvisoryMeetingFilters };
  },
);
